import { connect } from 'react-redux';
import AddPoc from './addPoc';
import { bindActionCreators } from 'redux';
import { addPoc, getPocById, editPoc } from 'services/redux/brandActivtion/poc/action';
import {getPocListing} from "../../../services/redux/brandActivtion/pocListing/action";
import {updatePocStatus,updateBaPocStatus} from "services/redux/brandActivtion/pocListing/action";


const mapStateToProps = state => ({
    pocDetails: state.baPocReducer.pocDetails,
    pocById: state.baPocReducer.pocById,
    pocList: state.pocListReducer.pocList,
    updateStatus: state.baPocListReducer.updatePocStatus,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    addPoc,
    getPocById,
    editPoc,
    getPocListing,
    updatePocStatus,
    updateBaPocStatus
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(AddPoc);
